<template>
  <div id="app">
    <transition>
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {};
  },
  watch: {
    $route() {
      ZP.setPageTitle(this.$route.meta.title || '博胜供应链管理系统');
    },
  },
  mounted() {},
  methods: {},
};
</script>
